import { useSelector } from 'react-redux';
import { Box, Tooltip, Image } from '@chakra-ui/react';
import CardDetails from './CardDetails';
import { useServicesDashboard } from 'context/ServicesDashboardContext';
import getServiceCardName from './helpers/serviceCardName';
import getServiceStatusLabel, {
    getCardPillOptions,
    getStatusPill,
} from './helpers/serviceStatusLabel';
import { GetCardStatus } from './helpers/cardStatusHelper';
import { sectionStatusTokens } from '../home/dashboardTokens';
import vendor from 'assets/images/vendor.png';
import { VENDOR_DEFINED, OPERATOR_PLATFORM } from '../constants';
import { isEmpty } from 'lodash';

const IconPlatform = ({ service, companyData }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const serviceStatus = useServicesDashboard();
    // The same status the section's accent and attention pulse are read from.
    const cardStatus = GetCardStatus(service, serviceStatus);

    // Ringed and labelled as the service card's status pill is, so the
    // badge never says something the card doesn't.
    const pillOptions = getCardPillOptions(service, companyData);
    const pillColor = getStatusPill(cardStatus, pillOptions).value;
    const serviceName = getServiceCardName(service);
    const statusText = getServiceStatusLabel(cardStatus, pillOptions);

    const tooltipLabel = statusText
        ? `${serviceName}: ${statusText}`
        : serviceName;
    const vendorCardImage = isEmpty(service.displayImage)
        ? vendor
        : // eslint-disable-next-line no-undef
          process.env.NODE_ENV === 'development'
          ? import.meta.env.VITE_APP_IMAGE_BASE +
            '/images/' +
            service.displayImage
          : window.location.origin + '/images/' + service.displayImage;

    // (3134) A small round badge per service in the collapsed section header,
    // ringed in its status colour, as in the TCAP Concept design.
    return (
        <Tooltip label={tooltipLabel} hasArrow openDelay={150}>
            <Box
                as="span"
                display="inline-flex"
                alignItems="center"
                justifyContent="center"
                boxSize="32px"
                flexShrink={0}
                borderRadius="full"
                border="2px solid"
                borderColor={sectionStatusTokens(pillColor, darkMode).accent}
                bg={darkMode ? 'dark.tcap' : 'white'}>
                <Image
                    src={
                        service?.serviceType === VENDOR_DEFINED ||
                        service?.serviceType === OPERATOR_PLATFORM
                            ? vendorCardImage
                            : CardDetails(service?.serviceType)?.icon
                    }
                    sx={{ maxWidth: '18px', maxHeight: '18px' }}
                />
            </Box>
        </Tooltip>
    );
};

export default IconPlatform;
